// The package's DatePicker turns off the popup's edge adjustment, so near the
// window's edge the panel opens off screen.
export const DATE_PICKER_POPUP_ALIGN = { overflow: { adjustX: true, adjustY: true } };
